/**
 * Mutationen der Review-Queue: apply/discard/retry/start invalidieren die
 * betroffenen Query-Keys (Muster `useListingBuilder.ts`: `onSuccess` →
 * `invalidateQueries`). estimate/preview sind reine Vorschau-Aufrufe ohne
 * Cache-Wirkung (Wizard-Kostenvorschau bzw. Sample-Preview, Q4).
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  applySuggestions,
  discardSuggestions,
  estimateRun,
  previewRecipe,
  retryFailedPairs,
  startRun,
} from '@/lib/api/channel-content-bulk'

import { textRunKeys } from './runStatus'

export function useTextRunMutations() {
  const qc = useQueryClient()
  const invalidateRuns = () =>
    qc.invalidateQueries({ queryKey: [...textRunKeys.all, 'runs'] })
  const invalidateSuggestionsAndRuns = () => {
    qc.invalidateQueries({ queryKey: [...textRunKeys.all, 'suggestions'] })
    invalidateRuns()
  }

  return {
    apply: useMutation({
      mutationFn: applySuggestions,
      onSuccess: invalidateSuggestionsAndRuns,
    }),
    discard: useMutation({
      mutationFn: discardSuggestions,
      onSuccess: invalidateSuggestionsAndRuns,
    }),
    retry: useMutation({
      mutationFn: retryFailedPairs,
      onSuccess: invalidateRuns,
    }),
    start: useMutation({
      mutationFn: startRun,
      onSuccess: invalidateRuns,
    }),
    estimate: useMutation({ mutationFn: estimateRun }),
    preview: useMutation({ mutationFn: previewRecipe }),
  }
}
